import jwt from '@/http/requests/auth/jwt'

export default {

  fetchArticleLists ({ commit }, organisationId) {
    return new Promise((resolve, reject) => {
      jwt.get('/api/admin/articlelist/list', { idOrganisation: organisationId })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchArticleList (context, id) {
    return new Promise((resolve, reject) => {
      const url = id ? `/api/admin/articlelist/${id}` : "/api/admin/articlelist/new"
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveArticleList (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/articlelist/save', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeRecord ({ commit }, id) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/articlelist/delete/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  syncFeed ({ commit }, id) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/articlelist/syncfeed/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchArticle (context, data) {
    return new Promise((resolve, reject) => {
      const url = data.id ? `/api/admin/article/${data.id}` : "/api/admin/article/new"
      jwt.get(url, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  activateArticle (context, id) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/article/activate/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deactivateArticle (context, id) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/article/deactivate/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchArticles (context, payload) {
    if (payload.searchValue) {
      payload.filterOptions = [
        { dataField: "Title", filterOperationEnum: "Contains", filterValue: payload.searchValue }
      ]
    }
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/article/list', payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveArticle (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/article/save', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeArticle ({ commit }, id) {
    return new Promise((resolve, reject) => {
      jwt.post(`/api/admin/article/delete/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  reorderArticles (context, data) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/article/reorder`
      jwt.post(url, data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchArticleListDefinition (context, id) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/articlelistdefinition/${id}`
      jwt.get(url)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  saveArticleListDefinition (context, data) {
    return new Promise((resolve, reject) => {
      jwt.post('/api/admin/articlelistdefinition/save', data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchArticleListDefinitionByIdArticleList (context, idArticleList) {
    return new Promise((resolve, reject) => {
      const url = `/api/admin/articlelist/${idArticleList}`
      jwt.get(url)
        .then((response) => {
          const al = response.data.articleList
          if (al.idArticleListDefinition) {
            jwt.get(`/api/admin/articlelistdefinition/${al.idArticleListDefinition}`)
              .then((response2) => {
                resolve(response2)
              })
              .catch((error) => {
                reject(error)
              })
          } else {
            const data = {
              idArticleList: al.id,
              idOrganisation: al.idOrganisation,
              name: `${al.name} Definition`,
              fields: [
                { "name": "callToActionText", "label": "Call To Action", "fieldType": "Text" },
                { "name": "imageUrl", "label": "Image", "fieldType": "Image" }
              ],
            }
            jwt.post(`/api/admin/articlelistdefinition/save`, data)
              .then((response2) => {
                resolve(response2)
              })
              .catch((error) => {
                reject(error)
              })
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

}
